import React, { useContext, useEffect, useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import "../../Styles/Form/FormCreate.css";
import ReactQuill from "react-quill";
import {
  removeSectionAndQuestion,
  reomveTag,
  updateFormDescription,
  updateFormTitile,
} from "../../Redux/Reducer/FormSlices";
import { useDispatch } from "react-redux";
import more from "../../Assets/more.svg";
import { useSelector } from "react-redux";
import { SelectTag } from "../Tags/SelectTag";
import Addtag from "../Tags/Addtag";
import { FaTags } from "react-icons/fa";
import axios from "axios";
import chevron_forward_active from "../../Assets/chevron-forward-active.svg";
import chevron_forward from "../../Assets/chevron-forward.svg";
import MoveSectionModel from "./MoveSectionModel";
import { PageContext } from "../../Context/PageContext";

const allTags = [
  {
    tagName: "Customer Feedback",
    tagColor: "#039BE6",
    tagIcon: "FaArrowAltCircleDown",
  },
  {
    tagName: "School Feedback",
    tagColor: "#EC773F",
    tagIcon: "FaArrowAltCircleDown",
  },
  {
    tagName: "Company Feedback",
    tagColor: "#E60303",
    tagIcon: "FaArrowAltCircleDown",
  },
  {
    tagName: "Steel survey",
    tagColor: "#616161",
    tagIcon: "FaArrowAltCircleDown",
  },
  {
    tagName: "Stores",
    tagColor: "#005080",
    tagIcon: "FaArrowAltCircleDown",
  },
  {
    tagName: "Hello World",
    tagColor: "#18A915",
    tagIcon: "FaArrowAltCircleDown",
  },
];

const Container = ({
  id,
  children,
  title,
  activeContainerIndex,
  sectionIndex,
  sectionLength,
  tags,
}) => {
  const {
    attributes,
    setNodeRef,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: id,
    data: {
      type: "container",
    },
  });
  const dispatch = useDispatch();
  const [isFocusedTitle, setIsFocusedTitle] = useState(false);
  const [isFocusedDescription, setIsFocusedDescription] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [showSectionDel, setShowSectionDel] = useState(false);
  //section action
  const [isOpenSection, setOpenSection] = useState(false);
  const { setShowSectionMoveModal } = useContext(PageContext);
  
  
  const toolbarOptions = [["bold", "italic", "underline"], ["link"]];
  const module = {
    toolbar: toolbarOptions,
  };
  

  const handleContainerTitleChange = (value) => {
    dispatch(updateFormTitile({ value, activeContainerIndex }));
  };
  const handleDescriptionChange = (value) => {
    dispatch(updateFormDescription({ value, activeContainerIndex }));
  };

  const openSectionSectting = () => {
    setOpenSection(!isOpenSection);
  };

  const deleteSection = () => {
    setShowSectionDel(false);
    setOpenSection(false);
  };
  const delSectionQuestion = (sectionIndex) => {
    setShowSectionDel(false);
    setOpenSection(false);
    dispatch(removeSectionAndQuestion({ sectionIndex }));
  };

  return (
    <>
      <div
        {...attributes}
        ref={setNodeRef}
        style={{
          transition,
          transform: CSS.Translate.toString(transform),
        }}
        className="inner "
      >
        <div className="sections_container">
          <div className="top-formbar">
            {sectionLength > 1 && (
              <div
                style={{
                  backgroundColor: "#ffffff",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  height: "2.5rem",
                  alignItems: "center",
                  fontWeight: "700",
                  fontFamily: "EuclidBold",
                  borderRadius: "0.75rem",
                }}
              >
                <div>
                  Section {sectionIndex + 1} of {sectionLength}
                </div>
                <div className="section-more-action">
                  <img
                    src={more}
                    alt="more"
                    onClick={() => openSectionSectting()}
                  />
                  {isOpenSection && (
                    <div className="section-model">
                      <p className="model_li">Duplicate Section</p>
                      <p
                        className="model_li"
                        onClick={() => setShowSectionMoveModal(true)}
                      >
                        Move section
                      </p>
                      <p
                        className="model_li remove-section"
                        onMouseEnter={() => setHovered(true)}
                        onMouseLeave={() => setHovered(false)}
                        onClick={() => setShowSectionDel(!showSectionDel)}
                      >
                        Remove section
                        <span>
                          <img
                            src={
                              hovered ? chevron_forward_active : chevron_forward
                            }
                            alt="chevron_forward"
                          />
                        </span>
                      </p>
                      <p className="model_li">Add branching</p>
                    </div>
                  )}
                  {showSectionDel && (
                    <div className="section_del">
                      <p className="model_li" onClick={() => deleteSection()}>
                        Section
                      </p>
                      <p
                        className="model_li"
                        onClick={() => delSectionQuestion(sectionIndex)}
                      >
                        Section and question
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="">
              <ReactQuill
                modules={module}
                theme="snow"
                value={title.sectionTitle}
                className={`custom-quill ${isFocusedTitle ? "focus" : ""}`}
                onFocus={() => setIsFocusedTitle(true)}
                onBlur={() => setIsFocusedTitle(false)}
                onChange={handleContainerTitleChange}
              />
            </div>
            {sectionIndex === 0 && <></>}
            <div className="">
              <ReactQuill
                modules={module}
                theme="snow"
                value={title.sectionDescription}
                className={`custom ${isFocusedDescription ? "focus" : ""}`}
                onFocus={() => setIsFocusedDescription(true)}
                onBlur={() => setIsFocusedDescription(false)}
                onChange={handleDescriptionChange}
              />
            </div>
          </div>
        </div>
        {children}
        {sectionLength !== sectionIndex + 1 && <NextSection />}
      </div>
    </>
  );
};

export default Container;

const NextSection = () => {
  return (
    <div className="nextSection_container">
      <div className="currentSection">After section 1 : </div>
      <div className="sectionSection">Continue to next section</div>
    </div>
  );
};
